import { SVGProps } from 'react';

const IcSend = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' {...props}>
    <path
      d='M21.6695 1.05616C22.0321 0.92925 22.4355 1.02133 22.7071 1.29297C22.9788 1.56461 23.0708 1.96798 22.9439 2.33057L15.9439 22.3306C15.8084 22.7175 15.4502 22.9823 15.0406 22.999C14.6311 23.0156 14.2531 22.7808 14.0865 22.4063L10.2423 13.7573L1.59384 9.91358C1.21934 9.74704 0.984457 9.369 1.00107 8.95948C1.01778 8.54987 1.28263 8.19166 1.66953 8.05616L21.6695 1.05616ZM12.1925 13.2212L14.8893 19.2891L19.6085 5.80518L12.1925 13.2212ZM4.71054 9.11036L10.7784 11.8071L18.1944 4.39112L4.71054 9.11036Z'
      fill={props.fill || '#232F3E'}
    />
  </svg>
);

export default IcSend;
